The parties that executed the action.

At least one party is required for a process history item of an uploaded candidate.
A maximum of 10 primary parties may be provided.
